// import React, { useCallback, useState } from 'react';
// import ChatSidebar from './Pages/chat-sidebar';
// import ChatContent from './Pages/chat-content';
// import { useNavigate, useParams } from 'react-router-dom';
// import { useDispatch } from 'react-redux';
// import { useGetSocket } from './socket';
// import { useMyChatsQuery } from './api/api';
// import { useErrors, useSocketEvents } from './hooks/hook';
// import { ONLINE_USERS, REFETCH_CHATS } from './constants/events';

// export default function Chatview() {
//   const [selectedUser, setSelectedUser] = useState(null);

//   const params = useParams();
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const socket = useGetSocket();
//   const chatId = params.chatId;

//   const [onlineUsers, setOnlineUsers] = useState([]);

//   return (
//     <div className="flex h-screen">
//       {/* Sidebar */}
//       <ChatSidebar
//         onSelectUser={setSelectedUser}

//       />

//       {/* Chat Content */}
//       <ChatContent selectedUser={selectedUser} />
//     </div>
//   );
// }
import React, { useState } from 'react';
import ChatSidebar from './Pages/chat-sidebar';
import ChatContent from './Pages/chat-content';

const ChatView = () => {
  const [selectedUser, setSelectedUser] = useState(null);

  return (
    <div className="flex h-screen">
      <ChatSidebar onSelectUser={setSelectedUser} />
      <ChatContent selectedUser={selectedUser} />
    </div>
  );
};

export default ChatView;
